import React from "react";
import { prettyPrintJson } from 'pretty-print-json';

import {Accordion, AccordionSummary, CircularProgress, Stack,} from "@mui/joy";
import Typography from "@mui/joy/Typography";
import Card from "@mui/joy/Card";
import Button from "@mui/joy/Button";
import AccordionDetails from "@mui/joy/AccordionDetails";

// components
import UserSubscriberContext from "../../context/UserSubscriberContext";
import BaseApi from "../../utils/BaseApi";
import withRouter from "../../utils/withRouter";
import CommonPaginatedComponentList from "../Common/CommonPaginatedComponentList";
import AgentRunStepCard from "./AgentRunStepCard";
import {CommonJSONField} from "../Common/CommonJSONFieldForm";
import VariableRepresentation from "./VariableRepresentation";
import CommonForm from "../Common/CommonForm";
import {retrieveModelField} from "../../utils/misc";
import {camelToSnakeCase} from "../Common/utils";


import 'pretty-print-json/css/pretty-print-json.prefers.min.css'

// icons
import CheckCircleIcon from "@mui/icons-material/CheckCircle";


class AgentRunDetail extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            agentRun: null,
            agentRunSteps: null,
            formFields: [],
        };
    }

    async componentDidMount() {
        await this.reload();
    }

    async reload(){
        await this.retrieveAgentRun();
        await this.retrieveAgentRunSteps();
    }

    async retrieveAgentRun(){
        await this.setState(
            {
                agentRun: null,
            }
        );
        const api = new BaseApi();
        let url = `agent_run/${this.props.params.agentRunId}`
        let response = await api.get(url, {});
        await this.setState(
            {
                agentRun: response.data
            },
            async () => {
                if (!this.state.agentRun.started){
                    await this.constructForm();
                }

            }
        );
    }

    async retrieveAgentRunSteps(){
        await this.setState(
            {
                agentRunSteps: null,
            }
        );
        const api = new BaseApi();
        let url = `agent_run_step/`
        let params = {
            run: this.props.params.agentRunId,
            page_size: 10000,
        }
        let response = await api.get(url, params);
        await this.setState(
            {
                agentRunSteps: response.data.results
            }
        );
    }

    async onSubmit(event) {
        event.preventDefault();
        let formDataObj = Object.fromEntries(
            (new FormData(event.currentTarget)).entries()
        );
        for (const [key, value] of Object.entries(formDataObj)) {
            formDataObj[key] = JSON.parse(value)
        }
        const url = `agent_run/${this.props.params.agentRunId}/`;
        const api = new BaseApi();
        await api.patch(
            url,
            formDataObj
        );
        await this.reload()
    }

    async constructForm(){
        this.setState(
            {
                formFields: [],
            }
        );
        let formFields = []
        for (let [variable, options] of Object.entries(this.state.agentRun.agent.run_variables)){
            switch (options?.type) {
                case 'int':
                    formFields.push(
                        {
                            name: variable,
                            label: options.title,
                            xs: 12,
                            sm: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                            required: options.required,
                            default: this.state.agentRun.run_variables[variable] || options.default,
                            type: "number"
                        }
                    )
                    break;
                case 'float':
                    formFields.push(
                        {
                            name: variable,
                            label: options.title,
                            xs: 12,
                            sm: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                            required: options.required,
                            default: this.state.agentRun.run_variables[variable] || options.default,
                            type: "float"
                        }
                    )
                    break;
                case 'entity':
                    let params = options.params;
                    if (options.fields){
                        params._serializer_filter_fields = JSON.stringify(
                        [
                                ...options.fields,
                                'id'
                            ]
                        )
                    }
                    let field = await retrieveModelField(
                        camelToSnakeCase(options.entity),
                        params,
                        variable,
                        options.title,
                        'id',
                        options.labelList || ['system_title'],
                        'Не выбрано',
                        "-1",
                        options.required
                    )

                    formFields.push(field)
                    break;
                case 'textarea':
                    formFields.push(
                        {
                            name: variable,
                            label: options.title || variable,
                            xs: 12,
                            sm: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                            required: options.required,
                            default: this.state.agentRun.run_variables[variable] || options.default,
                            type: "simpleTextarea"
                        }
                    )
                    break;
                default:
                    formFields.push(
                        {
                            name: variable,
                            label: options.title || variable,
                            xs: 12,
                            sm: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                            required: options.required,
                            default: this.state.agentRun.run_variables[variable] || options.default,
                            type: "input"
                        }
                    )
                    break;
            }
        }
        formFields.push(
            {
                name: 'process',
                label: 'Запустить после сохранения',
                xs: 12,
                sm: 12,
                md: 12,
                lg: 12,
                xl: 12,
                required: false,
                default: false,
                type: "checkbox"
            }
        )
        formFields.push(
            {
                type: "submit",
                label: "Сохранить",
                color: 'success',
            }
        )
        this.setState(
            {
                formFields: formFields,
            }
        );
    }

    async processForm(form) {
        let formDataObj = Object.fromEntries(
            form.state.formData.entries()
        );
        let process = formDataObj.process;
        delete formDataObj.process;
        const url = `agent_run/${this.props.params.agentRunId}/`;
        const api = new BaseApi();
        await api.patch(
            url,
            {
                run_variables: formDataObj
            }
        );

        if (process){
            await this.process()
        }
        else {
            await this.reload()
        }

    }

    async process() {
        const api = new BaseApi();
        let url = `agent_run/${this.props.params.agentRunId}/process`
        await api.get(
            url,
            {}
        );
        await this.reload()
    }

    async refresh() {
        const api = new BaseApi();
        let url = `agent_run/${this.props.params.agentRunId}/refresh`
        await api.get(
            url,
            {}
        );
        await this.reload()
    }

    render() {
        if (!this.state.agentRun || !this.state.agentRunSteps){
            return (<CircularProgress/>)
        }
        return(
            <Stack
                spacing={2}
                sx={{
                    width: '100%'
                }}
            >
                <Stack
                    direction={'row'}
                    spacing={1}
                    sx={{
                        width: '100%'
                    }}
                >
                    <Typography
                        level="body-lg"
                    >
                        # {this.state.agentRun.id} - {this.state.agentRun.agent.title}
                    </Typography>
                    {
                        this.state.agentRun.completed ?
                            <CheckCircleIcon
                                color={'success'}
                                sx={{display: 'flex'}}
                            /> : null
                    }
                    {
                        this.state.agentRun.started?
                            null:
                            <Button
                                onClick={this.process.bind(this)}
                                color={'success'}
                            >
                                Запустить
                            </Button>
                    }
                    <Button
                        onClick={this.reload.bind(this)}
                        color={'primary'}
                    >
                        Обновить
                    </Button>
                    <Button
                        onClick={this.refresh.bind(this)}
                        color={'warning'}
                    >
                        Откатить запуск
                    </Button>
                </Stack>
                <Stack
                    direction={'row'}
                    spacing={1}
                    sx={{
                        width: '100%'
                    }}
                >
                    <Stack
                        spacing={1}
                        sx={{
                            width: '50%'
                        }}
                    >
                        <Typography
                            level="title-md"
                        >
                            Переменные запуска
                        </Typography>
                        <Card
                            sx={{
                                height: '450px',
                                overflow: 'scroll',

                            }}
                        >
                            {
                                this.state.agentRun.started?
                                    <Stack
                                        direction={'row'}
                                        spacing={1}
                                        useFlexGap
                                        sx={{
                                            flexWrap: 'wrap',
                                            alignItems: 'center',
                                        }}
                                    >
                                        {
                                            Object.entries(this.state.agentRun.run_variables).map(k => (
                                                <VariableRepresentation
                                                    name={k[0]}
                                                    value={k[1]}
                                                    type={this.state.agentRun.agent.run_variables[k[0]]?.type}
                                                />
                                            ))
                                        }
                                    </Stack>:
                                    <Stack>
                                        {
                                            !this.state.formFields.length?
                                            <Stack>
                                                <Typography>
                                                    Дождитесь загрузки формы
                                                </Typography>
                                                <CircularProgress/>
                                            </Stack>:
                                            <CommonForm
                                                fields={this.state.formFields}
                                                processForm={this.processForm.bind(this)}
                                                object={this.state.agentRun.run_variables}
                                            />
                                        }

                                        <Accordion>
                                            <AccordionSummary>Сырой вид</AccordionSummary>
                                            <AccordionDetails>
                                                <form
                                                    onSubmit={this.onSubmit.bind(this)}
                                                >
                                                    <Stack
                                                        spacing={1}
                                                    >
                                                        <CommonJSONField
                                                            row={20}
                                                            defaultValue={this.state.agentRun.run_variables}
                                                            name={'run_variables'}
                                                        />
                                                        <Button type="submit" fullWidth>
                                                            Сохранить
                                                        </Button>
                                                    </Stack>
                                                </form>
                                            </AccordionDetails>
                                        </Accordion>
                                    </Stack>
                            }

                        </Card>
                    </Stack>
                    <Stack
                        spacing={1}
                        sx={{
                            width: '50%'
                        }}
                    >
                        <Typography
                            level="title-md"
                        >
                            Результаты
                        </Typography>
                        <Card
                            sx={{
                                height: '450px',
                                overflow: 'scroll'
                            }}
                        >
                            <Stack
                                spacing={1}
                            >

                                <Typography>
                                    Ключевые
                                </Typography>
                                <Stack
                                    direction={'row'}
                                    spacing={1}
                                    useFlexGap
                                    sx={{
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                    }}
                                >
                                    {
                                        Object.entries(this.state.agentRun.result_variables).filter(e => this.state.agentRun.agent.result_variables[e[0]]?.featured).map(k => (
                                            <VariableRepresentation
                                                name={k[0]}
                                                value={k[1]}
                                                type={this.state.agentRun.agent.result_variables[k[0]]?.type}
                                            />
                                        ))
                                    }
                                </Stack>
                                <Typography>
                                    Прочие
                                </Typography>
                                <Stack
                                    direction={'row'}
                                    spacing={1}
                                    useFlexGap
                                    sx={{
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                    }}
                                >
                                    {
                                        Object.entries(this.state.agentRun.result_variables).filter(e => !this.state.agentRun.agent.result_variables[e[0]]?.featured).map(k => (
                                            <VariableRepresentation
                                                name={k[0]}
                                                value={k[1]}
                                                type={this.state.agentRun.agent.result_variables[k[0]]?.type}
                                            />
                                        ))
                                    }
                                </Stack>

                                <Accordion>
                                    <AccordionSummary>Сырой вид</AccordionSummary>
                                    <AccordionDetails>
                                        <pre
                                            style={{
                                                whiteSpace: 'pre-wrap',
                                                wordWrap: 'break-word'
                                            }}
                                            className={'json-container'}
                                            dangerouslySetInnerHTML={{
                                            __html: prettyPrintJson.toHtml(
                                                this.state.agentRun.result_variables,
                                                {
                                                    indent: 4,
                                                    quoteKeys: "",
                                                }
                                            )
                                        }} />
                                    </AccordionDetails>
                                </Accordion>
                            </Stack>
                        </Card>
                    </Stack>
                </Stack>
                <Accordion>
                    <AccordionSummary>Шаги</AccordionSummary>
                    <AccordionDetails>
                    <CommonPaginatedComponentList
                        data={this.state.agentRunSteps}
                        component={AgentRunStepCard}
                        componentKeyword={'agentRunStep'}
                    />
                    </AccordionDetails>
                </Accordion>
            </Stack>
        )
    }
}

export default withRouter(AgentRunDetail);
